/* Twisted Suds: show the ingredient paragraph for the chosen fragrance.
   This only changes presentation; it does not validate or alter product formulas. */
(function () {
  if (window.__sudsIngredientClarityInstalled) return;
  window.__sudsIngredientClarityInstalled = true;

  var allowed = {
    'twisted-suds-whipped-sugar-scrub': true,
    'twisted-suds-classic-sugar-scrubs': true,
    'twisted-suds-solid-lotion-bars': true
  };
  function normalize(text) {
    return String(text || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
  }
  function currentFragrance(handle) {
    var selector = 'variant-selects[data-product-handle="' + handle + '"]';
    var picker = document.querySelector('product-info ' + selector) || document.querySelector(selector);
    if (!picker) return '';
    var first = picker.querySelector('.product-form__input select, .product-form__input input[type="radio"]:checked');
    return first ? first.value : '';
  }
  function resolveName(handle, fragrance) {
    var name = normalize(fragrance);
    if (handle === 'twisted-suds-solid-lotion-bars' && name === 'brewedbutter') {
      return 'brewedandbuttered';
    }
    return name;
  }
  function currentOption(handle, index) {
    var picker = document.querySelector('product-info variant-selects[data-product-handle="' + handle + '"]') ||
      document.querySelector('variant-selects[data-product-handle="' + handle + '"]');
    if (!picker) return '';
    var groups = Array.from(picker.querySelectorAll('.product-form__input'));
    var group = groups[index];
    if (!group) return '';
    var element = group.querySelector('select') || group.querySelector('input[type="radio"]:checked');
    return element ? element.value : '';
  }
  function refreshFizzCare(details, handle) {
    var panel = details.querySelector('[data-suds-fizz-care]');
    if (!panel) return;
    var isBath = panel.getAttribute('data-suds-fizz-kind') === 'bath';
    var selected = currentOption(handle, isBath ? 1 : 0);
    if (!selected) return;
    var name = panel.querySelector('[data-suds-fizz-name]');
    if (name) name.textContent = 'Selected fragrance: ' + selected.replace(/\s*\(Secret Toy\)/, '');
    var special = false;
    panel.querySelectorAll('[data-suds-fizz-special]').forEach(function (item) {
      var visible = item.getAttribute('data-suds-fizz-special') === selected.replace(/\s*\(Secret Toy\)/, '');
      item.hidden = !visible;
      item.style.display = visible ? '' : 'none';
      special = special || visible;
    });
    var fallback = panel.querySelector('[data-suds-fizz-fallback]');
    if (fallback) {
      fallback.hidden = special;
      fallback.style.display = special ? 'none' : '';
    }
    var toy = isBath && /\(Secret Toy\)/.test(selected);
    var toyNote = panel.querySelector('[data-suds-fizz-toy]');
    var noToyNote = panel.querySelector('[data-suds-fizz-no-toy]');
    if (toyNote) {
      toyNote.hidden = !toy;
      toyNote.style.display = toy ? '' : 'none';
    }
    if (noToyNote) {
      noToyNote.hidden = toy;
      noToyNote.style.display = toy ? 'none' : '';
    }
  }
  function refresh() {
    document.querySelectorAll('details.suds-product-details[data-suds-product-handle]').forEach(function (details) {
      var handle = details.getAttribute('data-suds-product-handle');
      if (handle === 'twisted-suds-bath-bombs' || handle === 'twisted-suds-shower-steamers') {
        refreshFizzCare(details, handle);
        return;
      }
      if (handle === 'magnesium-moon-2-0') {
        var selectedScent = currentFragrance(handle);
        details.querySelectorAll('[data-suds-mm2-scent]').forEach(function (item) {
          var visible = item.getAttribute('data-suds-mm2-scent') === selectedScent;
          item.hidden = !visible;
          item.style.display = visible ? '' : 'none';
        });
        return;
      }
      if (!allowed[handle]) return;
      var chosen = resolveName(handle, currentFragrance(handle));
      if (!chosen) return;

      var headings = Array.from(details.querySelectorAll('.rte h4'));
      var heading = headings.find(function (h) { return /^ingredients\b/i.test(h.textContent.trim()); });
      if (!heading) return;

      var paragraphs = [];
      for (var node = heading.nextElementSibling; node; node = node.nextElementSibling) {
        if (/^H[2-6]$/.test(node.tagName)) break;
        if (node.tagName !== 'P') continue;
        var label = node.querySelector('strong');
        if (label && /:\s*$/.test(label.textContent.trim())) {
          paragraphs.push({ element: node, name: normalize(label.textContent.replace(/:\s*$/, '')), text: label.textContent.replace(/:\s*$/, '') });
        }
      }
      if (paragraphs.length < 2) return;

      var match = paragraphs.find(function (item) {
        return item.name === chosen || item.name.indexOf(chosen) === 0 || chosen.indexOf(item.name) === 0;
      });
      // If the label changes or is ambiguous, show all rather than hide the wrong formula.
      var brewedIngredientMismatch = handle === 'twisted-suds-solid-lotion-bars' && chosen === 'brewedandbuttered';
      paragraphs.forEach(function (item) {
        var hide = Boolean((match && item !== match) || (brewedIngredientMismatch && item === match));
        item.element.hidden = hide;
        item.element.style.display = hide ? 'none' : '';
      });

      var notice = details.querySelector('[data-suds-chosen-ingredients]');
      if (!notice) {
        notice = document.createElement('p');
        notice.setAttribute('data-suds-chosen-ingredients', '');
        notice.setAttribute('role', 'status');
        notice.style.margin = '.5rem 0';
        heading.insertAdjacentElement('afterend', notice);
      }
      if (brewedIngredientMismatch) {
        notice.textContent = 'Brewed & Buttered ingredients: Coffee-infused high-oleic sunflower oil, beeswax, cocoa butter, shea butter, cetyl alcohol, arrowroot powder, and fragrance oils (Coffee Bean Element, Coconut Soleil, Vanilla Cake Pop).';
      } else {
        notice.textContent = match ? 'Ingredient information for: ' + match.text.replace(/:\s*$/, '') : 'Ingredient information varies by fragrance. Check the entry matching your selection.';
      }
    });
  }
  function queueRefresh() {
    if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(refresh);
    else refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-selects')) queueRefresh();
  });
  document.addEventListener('product-info:loaded', queueRefresh);
  document.addEventListener('shopify:section:load', queueRefresh);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, queueRefresh);
  }
})();